var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditCardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V8.2C3 7.08 3 6.52 3.218 6.092C3.41 5.715 3.715 5.41 4.092 5.218C4.52 5 5.08 5 6.2 5H12.5M3 9H12.5M3 9V15.8C3 16.92 3 17.48 3.218 17.908C3.40974 18.2843 3.71569 18.5903 4.092 18.782C4.519 19 5.079 19 6.197 19H17.803C18.921 19 19.48 19 19.907 18.782C20.284 18.59 20.59 18.284 20.782 17.908C21 17.48 21 16.922 21 15.804V11M16 7.322L17.484 8.898C17.5171 8.93194 17.557 8.95851 17.6011 8.97596C17.6452 8.99342 17.6925 9.00137 17.7399 8.99929C17.7873 8.99721 17.8337 8.98516 17.8761 8.96391C17.9185 8.94267 17.956 8.91271 17.986 8.876L21 5M6 15H10",
    stroke: "#36383E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCardCheck);
export default __webpack_public_path__ + "static/media/icon-credit-card-check.bd1974b79e5d89931e26028714b81d90.svg";
export { ForwardRef as ReactComponent };